// import ana1 from '/assets/artists/ana/ana1.jpg'
// import ana3 from '/assets/artists/ana/ana3.jpg'
// import ana4 from '/assets/artists/ana/ana4.jpg'
// import ana5 from '/assets/artists/ana/ana5.jpg'
// import ana6 from '/assets/artists/ana/ana6.jpg'
// import camilo1 from '/assets/artists/camilo/camilo1.jpg'
// import camilo2 from '/assets/artists/camilo/camilo2.jpg'
// import camilo3 from '/assets/artists/camilo/camilo3.jpg'
// import camilo4 from '/assets/artists/camilo/camilo4.jpg'
// import camilo5 from '/assets/artists/camilo/camilo5.jpg'
// import camilo6 from '/assets/artists/camilo/camilo6.jpg'
// import clara1 from '/assets/artists/clara/clara1.jpg'
// import clara2 from '/assets/artists/clara/clara2.jpg'
// import clara3 from '/assets/artists/clara/clara3.jpg'
// import clara4 from '/assets/artists/clara/clara4.jpg'
// import clara5 from '/assets/artists/clara/clara5.jpg'
// import clara6 from '/assets/artists/clara/clara6.jpg'
// import daniel1 from '/assets/artists/daniel/daniel1.jpg'
// import daniel2 from '/assets/artists/daniel/daniel2.jpg'
// import daniel3 from '/assets/artists/daniel/daniel3.jpg'
// import daniel4 from '/assets/artists/daniel/daniel4.jpg'
// import daniel5 from '/assets/artists/daniel/daniel5.jpg'
// import daniel6 from '/assets/artists/daniel/daniel6.jpg'
// import edna1 from '/assets/artists/edna/edna1.jpg'
// import edna2 from '/assets/artists/edna/edna2.jpg'
// import edna3 from '/assets/artists/edna/edna3.jpg'
// import edna4 from '/assets/artists/edna/edna4.jpg'
// import edna5 from '/assets/artists/edna/edna5.jpg'
// import edna6 from '/assets/artists/edna/edna6.jpg'
// import filipe1 from '/assets/artists/filipe/filipe1.jpg'
// import filipe2 from '/assets/artists/filipe/filipe2.jpg'
// import filipe3 from '/assets/artists/filipe/filipe3.jpg'
// import filipe4 from '/assets/artists/filipe/filipe4.jpg'
// import filipe5 from '/assets/artists/filipe/filipe5.jpg'
// import filipe6 from '/assets/artists/filipe/filipe6.jpg'
// import isabela1 from '/assets/artists/isabela/isabela1.jpg'
// import isabela2 from '/assets/artists/isabela/isabela2.jpg'
// import isabela3 from '/assets/artists/isabela/isabela3.jpg'
// import isabela4 from '/assets/artists/isabela/isabela4.jpg'
// import isabela5 from '/assets/artists/isabela/isabela5.jpg'
// import isabela6 from '/assets/artists/isabela/isabela6.jpg'
// import jessica1 from '/assets/artists/jessica/jessica1.jpg'
// import jessica2 from '/assets/artists/jessica/jessica2.jpg'
// import jessica3 from '/assets/artists/jessica/jessica3.jpg'
// import jessica4 from '/assets/artists/jessica/jessica4.jpg'
// import jessica5 from '/assets/artists/jessica/jessica5.jpg'
// import jessica6 from '/assets/artists/jessica/jessica6.jpg'
// import juliana1 from '/assets/artists/juliana/juliana1.jpg'
// import juliana2 from '/assets/artists/juliana/juliana2.jpg'
// import juliana3 from '/assets/artists/juliana/juliana3.jpg'
// import juliana4 from '/assets/artists/juliana/juliana4.jpg'
// import juliana5 from '/assets/artists/juliana/juliana5.jpg'
// import juliana6 from '/assets/artists/juliana/juliana6.jpg'
// import larissa1 from '/assets/artists/larissa/larissa1.jpg'
// import larissa2 from '/assets/artists/larissa/larissa2.jpg'
// import larissa3 from '/assets/artists/larissa/larissa3.jpg'
// import larissa4 from '/assets/artists/larissa/larissa4.jpg'
// import larissa5 from '/assets/artists/larissa/larissa5.jpg'
// import larissa6 from '/assets/artists/larissa/larissa6.jpg'
// import mariajulia1 from '/assets/artists/mariajulia/mariajulia1.jpg'
// import mariajulia2 from '/assets/artists/mariajulia/mariajulia2.jpg'
// import mariajulia3 from '/assets/artists/mariajulia/mariajulia3.jpg'
// import mariajulia4 from '/assets/artists/mariajulia/mariajulia4.jpg'
// import mariajulia5 from '/assets/artists/mariajulia/mariajulia5.jpg'
// import mariajulia6 from '/assets/artists/mariajulia/mariajulia6.jpg'
// import mauricio1 from '/assets/artists/mauricio/mauricio1.jpg'
// import mauricio2 from '/assets/artists/mauricio/mauricio2.jpg'
// import mauricio3 from '/assets/artists/mauricio/mauricio3.jpg'
// import mauricio4 from '/assets/artists/mauricio/mauricio4.jpg'
// import mauricio5 from '/assets/artists/mauricio/mauricio5.jpg'
// import mauricio6 from '/assets/artists/mauricio/mauricio6.jpg'
// import mayra1 from '/assets/artists/mayra/mayra1.jpg'
// import mayra2 from '/assets/artists/mayra/mayra2.jpg'
// import mayra3 from '/assets/artists/mayra/mayra3.jpg'
// import mayra4 from '/assets/artists/mayra/mayra4.jpg'
// import mayra5 from '/assets/artists/mayra/mayra5.jpg'
// import mayra6 from '/assets/artists/mayra/mayra6.jpg'
// import philippe1 from '/assets/artists/philippe/philippe1.jpg'
// import philippe2 from '/assets/artists/philippe/philippe2.jpg'
// import philippe3 from '/assets/artists/philippe/philippe3.jpg'
// import philippe4 from '/assets/artists/philippe/philippe4.jpg'
// import philippe5 from '/assets/artists/philippe/philippe5.jpg'
// import philippe6 from '/assets/artists/philippe/philippe6.jpg'
// import regi1 from '/assets/artists/regi/regi1.jpg'
// import regi2 from '/assets/artists/regi/regi2.jpg'
// import regi3 from '/assets/artists/regi/regi3.jpg'
// import regi4 from '/assets/artists/regi/regi4.jpg'
// import regi5 from '/assets/artists/regi/regi5.jpg'
// import regi6 from '/assets/artists/regi/regi6.jpg'
// import renato1 from '/assets/artists/renato/renato1.jpg'
// import renato2 from '/assets/artists/renato/renato2.jpg'
// import renato3 from '/assets/artists/renato/renato3.jpg'
// import renato4 from '/assets/artists/renato/renato4.jpg'
// import renato5 from '/assets/artists/renato/renato5.jpg'
// import renato6 from '/assets/artists/renato/renato6.jpg'
// import rinaldo1 from '/assets/artists/rinaldo/rinaldo1.jpg'
// import rinaldo2 from '/assets/artists/rinaldo/rinaldo2.jpg'
// import rinaldo3 from '/assets/artists/rinaldo/rinaldo3.jpg'
// import rinaldo4 from '/assets/artists/rinaldo/rinaldo4.jpg'
// import rinaldo5 from '/assets/artists/rinaldo/rinaldo5.jpg'
// import rinaldo6 from '/assets/artists/rinaldo/rinaldo6.jpg'
// import rosangela1 from '/assets/artists/rosangela/rosangela1.jpg'
// import rosangela2 from '/assets/artists/rosangela/rosangela2.jpg'
// import rosangela3 from '/assets/artists/rosangela/rosangela3.jpg'
// import rosangela4 from '/assets/artists/rosangela/rosangela4.jpg'
// import rosangela5 from '/assets/artists/rosangela/rosangela5.jpg'
// import rosangela6 from '/assets/artists/rosangela/rosangela6.jpg'
// import sofia1 from '/assets/artists/sofia/sofia1.jpg'
// import sofia2 from '/assets/artists/sofia/sofia2.jpg'
// import sofia3 from '/assets/artists/sofia/sofia3.jpg'
// import sofia4 from '/assets/artists/sofia/sofia4.jpg'
// import sofia5 from '/assets/artists/sofia/sofia5.jpg'
// import sofia6 from '/assets/artists/sofia/sofia6.jpg'
// import vico1 from '/assets/artists/vico/vico1.jpg'
// import vico2 from '/assets/artists/vico/vico2.jpg'
// import vico3 from '/assets/artists/vico/vico3.jpg'
// import vico4 from '/assets/artists/vico/vico4.jpg'
// import vico5 from '/assets/artists/vico/vico5.jpg'
// import vico6 from '/assets/artists/vico/vico6.jpg'

export default [
  {
    id: 'ana',
    artistName: 'Ana Kossoski',
    participacao: 'estudante',
    composicao: ['tipos'],
    images: [
      {
        src: '/assets/artists/ana/ana1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/ana/ana2.jpg'
      },
      {
        src: '/assets/artists/ana/ana3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/ana/ana4.jpg'
      },
      {
        src: '/assets/artists/ana/ana5.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/ana/ana6.jpg',
        filter: {
          papel: ['cinza']
        }
      }
    ]
  },
  {
    id: 'camilo',
    artistName: 'Camilo Maia',
    participacao: 'designer',
    composicao: ['tipos'],
    images: [
      {
        src: '/assets/artists/camilo/camilo1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/camilo/camilo2.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/camilo/camilo3.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/camilo/camilo4.jpg'
      },
      {
        src: '/assets/artists/camilo/camilo5.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/camilo/camilo6.jpg',
        filter: {
          papel: ['laranja']
        }
      }
    ]
  },
  {
    id: 'clara',
    artistName: 'Clara Simas',
    participacao: 'designer',
    composicao: ['clichê'],
    images: [
      {
        src: '/assets/artists/clara/clara1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/clara/clara2.jpg'
      },
      {
        src: '/assets/artists/clara/clara3.jpg',
        filter: {
          papel: ['cinza']
        }
      },
      {
        src: '/assets/artists/clara/clara4.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/clara/clara5.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/clara/clara6.jpg'
      }
    ]
  },
  {
    id: 'daniel',
    artistName: 'Daniel Santiago',
    participacao: 'artista',
    composicao: ['clichê', 'ornamentos'],
    images: [
      {
        src: '/assets/artists/daniel/daniel1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/daniel/daniel2.jpg',
        filter: {
          papel: ['branco', 'transparente']
        }
      },
      {
        src: '/assets/artists/daniel/daniel3.jpg',
        filter: {
          matriz: ['tipos']
        }
      },
      {
        src: '/assets/artists/daniel/daniel4.jpg',
        filter: {
          matriz: ['cliche']
        }
      },
      {
        src: '/assets/artists/daniel/daniel5.jpg',
        filter: {
          papel: ['laranja']
        }
      },
      {
        src: '/assets/artists/daniel/daniel6.jpg',
        filter: {
          papel: ['transparente']
        }
      }
    ]
  },
  {
    id: 'edna',
    artistName: 'Edna Lucia Cunha Lima',
    participacao: 'designer',
    composicao: ['fios'],
    images: [
      {
        src: '/assets/artists/edna/edna1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/edna/edna2.jpg',
        filter: {
          papel: ['cinza']
        }
      },
      {
        src: '/assets/artists/edna/edna3.jpg',
        filter: {
          papel: ['laranja']
        }
      },
      {
        src: '/assets/artists/edna/edna4.jpg'
      },
      {
        src: '/assets/artists/edna/edna5.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/edna/edna6.jpg',
        filter: {
          papel: ['transparente']
        }
      }
    ]
  },
  {
    id: 'filipe',
    artistName: 'Filipe Aca',
    participacao: 'estudante',
    composicao: ['tipos'],
    images: [
      {
        src: '/assets/artists/filipe/filipe1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/filipe/filipe2.jpg',
        filter: {
          papel: ['laranja']
        }
      },
      {
        src: '/assets/artists/filipe/filipe3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/filipe/filipe4.jpg',
        filter: {
          papel: ['cinza']
        }
      },
      {
        src: '/assets/artists/filipe/filipe5.jpg'
      },
      {
        src: '/assets/artists/filipe/filipe6.jpg',
        filter: {
          papel: ['branco']
        }
      }
    ]
  },
  {
    id: 'isabela',
    artistName: 'Isabela Stampanoni',
    participacao: 'artista',
    composicao: ['clichê', 'fios', 'ornamentos'],
    intervencao: ['nanquim'],
    images: [
      {
        src: '/assets/artists/isabela/isabela1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/isabela/isabela2.jpg',
        filter: {
          matriz: ['cliche']
        }
      },
      {
        src: '/assets/artists/isabela/isabela3.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/isabela/isabela4.jpg'
      },
      {
        src: '/assets/artists/isabela/isabela5.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/isabela/isabela6.jpg',
        filter: {
          papel: ['cinza']
        }
      }
    ]
  },
  {
    id: 'jessica',
    artistName: 'Jéssica Paiva',
    participacao: 'estudante',
    composicao: ['clichê'],
    images: [
      {
        src: '/assets/artists/jessica/jessica1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/jessica/jessica2.jpg',
        filter: {
          matriz: ['cliche']
        }
      },
      {
        src: '/assets/artists/jessica/jessica3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/jessica/jessica4.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/jessica/jessica5.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/jessica/jessica6.jpg',
        filter: {
          papel: ['laranja']
        }
      }
    ]
  },
  {
    id: 'juliana',
    artistName: 'Juliana Dias',
    participacao: 'estudante',
    composicao: ['tipos'],
    images: [
      {
        src: '/assets/artists/juliana/juliana1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/juliana/juliana2.jpg',
        filter: {
          papel: ['cinza']
        }
      },
      {
        src: '/assets/artists/juliana/juliana3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/juliana/juliana4.jpg',
        filter: {
          papel: ['laranja']
        }
      },
      {
        src: '/assets/artists/juliana/juliana5.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/juliana/juliana6.jpg'
      }
    ]
  },
  {
    id: 'larissa',
    artistName: 'Larissa Constantino',
    participacao: 'estudante',
    composicao: ['clichê'],
    images: [
      {
        src: '/assets/artists/larissa/larissa1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/larissa/larissa2.jpg',
        filter: {
          matriz: ['cliche']
        }
      },
      {
        src: '/assets/artists/larissa/larissa3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/larissa/larissa4.jpg',
        filter: {
          papel: ['cinza']
        }
      },
      {
        src: '/assets/artists/larissa/larissa5.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/larissa/larissa6.jpg',
        filter: {
          papel: ['transparente']
        }
      }
    ]
  },
  {
    id: 'mariajulia',
    artistName: 'Maria Júlia Rêgo',
    participacao: 'estudante',
    composicao: ['tipos'],
    intervencao: ['carimbo'],
    images: [
      {
        src: '/assets/artists/mariajulia/mariajulia1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/mariajulia/mariajulia2.jpg',
        filter: {
          matriz: ['tipos']
        }
      },
      {
        src: '/assets/artists/mariajulia/mariajulia3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/mariajulia/mariajulia4.jpg'
      },
      {
        src: '/assets/artists/mariajulia/mariajulia5.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/mariajulia/mariajulia6.jpg',
        filter: {
          papel: ['transparente']
        }
      }
    ]
  },
  {
    id: 'mauricio',
    artistName: 'Maurício Castro',
    participacao: 'artista',
    composicao: ['clichê'],
    images: [
      {
        src: '/assets/artists/mauricio/mauricio1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/mauricio/mauricio2.jpg',
        filter: {
          matriz: ['cliche']
        }
      },
      {
        src: '/assets/artists/mauricio/mauricio3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/mauricio/mauricio4.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/mauricio/mauricio5.jpg',
        filter: {
          papel: ['preto']
        }
      },
      {
        src: '/assets/artists/mauricio/mauricio6.jpg'
      }
    ]
  },
  {
    id: 'mayra',
    artistName: 'Mayra Melo',
    participacao: 'designer',
    composicao: ['clichê'],
    images: [
      {
        src: '/assets/artists/mayra/mayra1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/mayra/mayra2.jpg',
        filter: {
          papel: ['cinza']
        }
      },
      {
        src: '/assets/artists/mayra/mayra3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/mayra/mayra4.jpg',
        filter: {
          papel: ['laranja']
        }
      },
      {
        src: '/assets/artists/mayra/mayra5.jpg',
        filter: {
          papel: ['preto']
        }
      },
      {
        src: '/assets/artists/mayra/mayra6.jpg'
      }
    ]
  },
  {
    id: 'philippe',
    artistName: 'Philippe Souza',
    participacao: 'estudante',
    composicao: ['clichê'],
    images: [
      {
        src: '/assets/artists/philippe/philippe1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/philippe/philippe2.jpg',
        filter: {
          matriz: ['cliche']
        }
      },
      {
        src: '/assets/artists/philippe/philippe3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/philippe/philippe4.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/philippe/philippe5.jpg',
        filter: {
          papel: ['laranja']
        }
      },
      {
        src: '/assets/artists/philippe/philippe6.jpg'
      }
    ]
  },
  {
    id: 'regi',
    artistName: 'Régi Silva',
    participacao: 'estudante',
    composicao: ['clichê'],
    images: [
      {
        src: '/assets/artists/regi/regi1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/regi/regi2.jpg',
        filter: {
          papel: ['cinza']
        }
      },
      {
        src: '/assets/artists/regi/regi3.jpg',
        filter: {
          papel: ['laranja']
        }
      },
      {
        src: '/assets/artists/regi/regi4.jpg'
      },
      {
        src: '/assets/artists/regi/regi5.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/regi/regi6.jpg',
        filter: {
          papel: ['transparente']
        }
      }
    ]
  },
  {
    id: 'renato',
    artistName: 'Renato Valle',
    participacao: 'artista',
    composicao: ['ornamentos'],
    images: [
      {
        src: '/assets/artists/renato/renato1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/renato/renato2.jpg',
        filter: {
          matriz: ['tipos']
        }
      },
      {
        src: '/assets/artists/renato/renato3.jpg',
        filter: {
          papel: ['laranja']
        }
      },
      {
        src: '/assets/artists/renato/renato4.jpg'
      },
      {
        src: '/assets/artists/renato/renato5.jpg',
        filter: {
          papel: ['preto']
        }
      },
      {
        src: '/assets/artists/renato/renato6.jpg',
        filter: {
          papel: ['branco']
        }
      }
    ]
  },
  {
    id: 'rinaldo',
    artistName: 'Rinaldo Silva',
    participacao: 'artista',
    composicao: ['clichês', 'ornamentos'],
    intervencao: ['carimbo'],
    images: [
      {
        src: '/assets/artists/rinaldo/rinaldo1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/rinaldo/rinaldo2.jpg'
      },
      {
        src: '/assets/artists/rinaldo/rinaldo3.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/rinaldo/rinaldo4.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/rinaldo/rinaldo5.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/rinaldo/rinaldo6.jpg',
        filter: {
          papel: ['transparente']
        }
      }
    ]
  },
  {
    id: 'rosangela',
    artistName: 'Rosângela Vieira',
    participacao: 'designer',
    composicao: ['clichê'],
    intervencao: ['carimbo'],
    images: [
      {
        src: '/assets/artists/rosangela/rosangela1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/rosangela/rosangela2.jpg',
        filter: {
          matriz: ['cliche']
        }
      },
      {
        src: '/assets/artists/rosangela/rosangela3.jpg',
        filter: {
          papel: ['kraft']
        }
      },
      {
        src: '/assets/artists/rosangela/rosangela4.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/rosangela/rosangela5.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/rosangela/rosangela6.jpg',
        filter: {
          papel: ['transparente']
        }
      }
    ]
  },
  {
    id: 'sofia',
    artistName: 'Sofia L\'amour',
    participacao: 'estudante',
    composicao: ['clichê'],
    images: [
      {
        src: '/assets/artists/sofia/sofia1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/sofia/sofia2.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/sofia/sofia3.jpg',
        filter: {
          papel: ['cinza']
        }
      },
      {
        src: '/assets/artists/sofia/sofia4.jpg',
        filter: {
          papel: ['laranja']
        }
      },
      {
        src: '/assets/artists/sofia/sofia5.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/sofia/sofia6.jpg'
      }
    ]
  },
  {
    id: 'vico',
    participacao: 'estudante',
    artistName: 'Vico Soares',
    composicao: ['tipos'],
    intervencao: ['digital', 'nanquim', 'estêncil'],
    images: [
      {
        src: '/assets/artists/vico/vico1.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/vico/vico2.jpg'
      },
      {
        src: '/assets/artists/vico/vico3.jpg',
        filter: {
          papel: ['transparente']
        }
      },
      {
        src: '/assets/artists/vico/vico4.jpg',
        filter: {
          papel: ['branco']
        }
      },
      {
        src: '/assets/artists/vico/vico5.jpg',
        filter: {
          papel: ['preto']
        }
      },
      {
        src: '/assets/artists/vico/vico6.jpg',
        filter: {
          papel: ['preto']
        }
      }
    ]
  }
]
